import React, { Component } from "react";

import { Link } from "react-router-dom";
// import {Link} from 'react-router-dom'
import { Menu } from "semantic-ui-react";

import Footer from "./FooterMain";
import cas from "./casClient/CasService";
import {withRouter} from 'react-router'
import HeaderCommon from "./HeaderCommon";
import decode from "jwt-decode";
import {
  Navbar,
  NavbarNav,
  NavbarToggler,
  Collapse,
  NavItem,
  NavLink,
  Button,
} from "mdbreact";
// import { AuthConsumer } from "../../AuthContext";
class Layout extends Component {
  constructor(props) {
    super(props);
    this.state = {
      collapse: false,
      isWideEnough: false,
      dropdownOpenAbout: false,
      dropdownOpenTeams: false,
      dropdownOpenProjects: false,
    //   active:props.match.url==='/trainingnew'?'Training Home':props.match.url==='/trainingnew/courses'?'Courses':props.match.url==='/trainingnew/proj-obj'?'Objective':null,
      isOpen: false,
      username:null,
      ticketKey:null,
      modal:false
    };
  }

  handleLogin=async()=> {
    try {
      cas.redirect();
      let result=await cas.getLogin()
      console.log(result)
    } catch (err) {
      if (err.error !== "login_required") console.log("error: " + err);
    }
  }
  
  async componentDidMount() {
    console.log(window.sessionStorage.getItem("loginUser"))
    console.log(window.sessionStorage.getItem("ticketUser"))
    let resultf=cas.getLogin()
    console.log(resultf)
    if(resultf===null)
    {   
        cas.saveTicket();
      await cas.getTicketCAS();
       
          this.setState({
            username:cas.getLogin(),
            ticketKey:cas.getTicket()
          })
       
      }
      else
      {
        this.setState({
          username:window.sessionStorage.getItem("loginUser"),
          ticketKey:window.sessionStorage.getItem("ticketUser")
        })
      }
  
   

      // if (cas.isAuthenticated() && cas.getLogin()) {
      //   console.log("Login");
      //   const user = await auth.login(cas.getLogin());
      //   this.setState({ user, emailCas: cas.getLogin() });
      // }
      // //console.log(this.state.user);
      // this.getRoles();

      // const key = this.detectedOffline();
      // this.detectedOnLine(key);
   
  }
  handleLogout=()=>{

    
    cas.logout()
    this.props.history.replace('/nhp_cas/nhp-data-download')
  // casClient.logout();

 }
  onClick = () => {
    this.setState({
      collapse: !this.state.collapse,
    });
  };
  _handleClick(menuItem) {
    this.setState({ active: menuItem });
  }
 

  componentDidUpdate(prevProps,prevState)
  {
    if(this.props.match.url!==prevProps.match.url)
    {
     this.setState({
      active:this.props.match.url==='/trainingnew'?'Training Home':this.props.match.url==='/trainingnew/courses'?'Courses':this.props.match.url==='/trainingnew/proj-obj'?'Objective':null,
     })
    }
  }
  render() {
    // let menuList = menus.head.map((menu, key) => {
    //   return (
    //     <NavItem key={key}>
    //       <NavLink to={menu.path} key={key}>
    //         <Menu.Item
    //           name={menu.name}
    //           style={this.state.active === menu.name ? activeStyle : {}}
    //           onClick={this._handleClick.bind(this, menu.name)}
    //         />
    //       </NavLink>
    //     </NavItem>
    //   );
    // });
   console.log(this.state.username)
    return (
      <div className="wrapper">
        <HeaderCommon title=" Data Download " screentitle="Data Download" bhuvanlink={true} />
        <Navbar color="indigo" dark expand="md" scrolling>
          {!this.state.isWideEnough && <NavbarToggler onClick={this.onClick} />}
          <Collapse isOpen={this.state.collapse} navbar>
            <NavbarNav left>
            <NavItem >
            <NavLink to='/' >
            <Menu.Item>
              NHP Home
              </Menu.Item>
            </NavLink>
            </NavItem>
            </NavbarNav>
            
            <NavbarNav right>
            {this.state.username!==null && this.state.ticketKey!==null? <div>
       <Button className="btn-sm" outline color="yellow">
       Welcome{" "}
      <span style={{textTransform:"initial"}}>{this.state.username}</span>
     </Button>
       <Button className="btn-sm" outline color="yellow" onClick={this.handleLogout}>Logout</Button>
       </div>:<Button className="btn-sm" outline color="yellow"  onClick={this.handleLogin}>LogIn</Button>
       }
      
            </NavbarNav>
           
          </Collapse>
        </Navbar>

        <div className="main">{this.props.children}</div>

        <Footer />
      </div>
    );
  }
}

export default withRouter(Layout);
